package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme

/**
 * Settings / preferences list row: leading icon tile, title (+ optional subtitle), trailing chevron.
 * Set [destructive] for actions like Sign Out (renders in the error color, no chevron).
 */
@Composable
fun SettingsRow(
    iconName: String,
    title: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    subtitle: String? = null,
    destructive: Boolean = false,
) {
    val tint = if (destructive) AppTheme.colors.error else AppTheme.colors.primary
    val titleColor = if (destructive) AppTheme.colors.error else AppTheme.colors.onSurface
    Row(
        modifier = modifier
            .fillMaxWidth()
            .clickable(onClick = onClick)
            .padding(AppTheme.spacing.md),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
    ) {
        Box(
            modifier = Modifier
                .size(AppTheme.sizes.avatarMd)
                .background(AppTheme.colors.surfaceContainer, AppTheme.shapes.md),
            contentAlignment = Alignment.Center,
        ) {
            AppIcon(name = iconName, size = AppTheme.sizes.iconMd, tint = tint)
        }
        Column(modifier = Modifier.weight(1f)) {
            Text(text = title, style = AppTheme.typography.bodyLg, color = titleColor)
            if (subtitle != null) {
                Text(
                    text = subtitle,
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onSurfaceVariant,
                )
            }
        }
        if (!destructive) {
            AppIcon(name = "chevron_right", size = AppTheme.sizes.iconMd, tint = AppTheme.colors.onSurfaceVariant)
        }
    }
}
